<template lang="pug">
.product-recommendations
  products-grid(
    :loading="loading"
    :records="records"
    :placeholders="10"
    :trackProps="{zone: 'RECOMMENDED_PRODUCTS', recommendation_model: recommendationModel}")
</template>

<script>
import { mapGetters } from 'vuex'
import { uniqBy } from 'lodash'
import { PRODUCT_RECOMMENDATION_GROUP } from '~/settings'
import ProductsGrid from '~/components/products/ProductsGrid'

export default {
  components: {
    ProductsGrid
  },

  props: {
    product: {
      type: Object,
      required: true
    },
    selected: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      loading: false,
      records: []
    }
  },

  computed: {
    ...mapGetters({
      productRecommendationGroup: 'master/productRecommendationGroup'
    }),

    recommendationModel () {
      if (this.productRecommendationGroup === PRODUCT_RECOMMENDATION_GROUP.B) {
        return 'NEW'
      }
      return 'OLD'
    }
  },

  mounted () {
    // if (!this.$store.getters['authentication/isBuyer']) return

    this.loading = true
    const startTime = Date.now()
    this.$api.catalog.getProductRecommendations(this.product)
      .then(res => {
        const responseTime = Date.now() - startTime
        let records = [
          ...res.recommended_product_results || [],
          ...res.same_brand_results || [],
          ...res.same_product_type_results || []
        ]
        records = uniqBy(records, 'product_id')
        if (records.length === 0) records = res.top_sale_results || []
        this.records = records.slice(0, 10)

        this.$amplitude.track('RECOMMEND_PRODUCTS', {
          product_id: this.product.id,
          sku_id: this.selected.id,
          recommendation_model: this.recommendationModel,
          recommended_product_ids: this.records.map(e => e.product_id),
          zone: 'PRODUCT_DETAIL_FOOTER',
          response_time: responseTime
        })
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
